import Vue from "vue";
import Core from "@/core";
import VueMasonry from "vue-masonry-css";

// Plugins
// import FlagIcon from "vue-flag-icon";
import Vuelidate from "vuelidate";
import VCalendar from "v-calendar";
import Modals from "@/components/ui/modal";
import Breadcrumbs from "@/components/common/breadcrumbs/";

// Global components
import AppSimplebar from "@/components/ui/app/AppSimplebar";
import AppLoading from "@/components/ui/app/AppLoading";
import AppHover from "@/components/ui/app/AppHover";
import AppSkeleton from "@/components/ui/AppSkeleton";

import AppBtn from "@/components/ui/button/AppBtn";
import AppMenu from "@/components/ui/menus/AppMenu";
import AppSnackbar from "@/components/ui/snackbar/AppSnackbar";
import Tooltip from "@/components/ui/tooltip/Tooltip";
import ItemsNotFound from "@/components/ui/ItemsNotFound";
import AppCurrency from "@/components/common/AppCurrency";

import AppInput from "@/components/ui/input/AppInput.vue";
import AppSelect from "@/components/ui/select/Select.vue";
import AppDatePicker from "@/components/ui/input/AppDatePicker.vue";
import SvgIcon from "@/components/common/svg/IconBase";

import AppCard from "@/components/ui/cards/AppCard";
import CardScroller from "@/components/ui/cards/CardScroller";
import AppCardHeader from "@/components/ui/cards/AppCardHeader";
import CardMedia from "@/components/ui/cards/CardMedia";
import CardMediaContent from "@/components/ui/cards/CardMediaContent";
import InnerCard from "@/components/ui/cards/InnerCard";
import GroupCard from "@/components/ui/cards/GroupCard";
import GradientCard from "@/components/ui/cards/GradientCard";

import ContentBlock from "@/components/ui/ContentBlock";

import AppCheckbox from "@/components/ui/AppCheckbox";
import AppCheckboxLabel from "@/components/ui/AppCheckboxLabel";
import SectionTitle from "@/components/ui/SectionTitle";
import ImgPreview from "@/components/ui/ImgPreview";
import TextLined from "@/components/ui/TextLined";
import ContentText from "@/components/ui/ContentText";

import AppShape from "@/components/ui/shapes/AppShape";

Vue.use(VueMasonry);
Vue.use(Modals);
Vue.use(Breadcrumbs);

let components = {
  AppSimplebar,
  AppLoading,
  AppHover,
  AppBtn,
  AppDatePicker,
  AppInput,
  AppSelect,
  AppMenu,
  AppSnackbar,
  Tooltip,
  SvgIcon,
  AppCard,
  CardScroller,
  AppCardHeader,
  CardMedia,
  CardMediaContent,
  InnerCard,
  GroupCard,
  GradientCard,
  ItemsNotFound,
  AppCheckbox,
  AppCheckboxLabel,
  SectionTitle,
  ImgPreview,
  TextLined,
  ContentText,
  AppCurrency,
  AppShape,
  AppSkeleton,
  ContentBlock
};

// Init Core Plugin
Vue.use(Core, {
  components
});

Vue.use(Vuelidate);

// default theme here https://github.com/nathanreyes/v-calendar/blob/next/src/utils/defaults/theme.js
Vue.use(VCalendar, {
  firstDayOfWeek: 2, // Monday
  theme: {
    container: {
      light:
        "vc-text-gray-900 vc-bg-white vc-border vc-border-gray-400 vc-rounded"
    }
  }
});
